import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useState} from 'react'
import { useFragment, usePreloadedQuery} from 'react-relay'


import useAtmosphere from '../hooks/useAtmosphere'
import useMutationProps from '../hooks/useMutationProps'
import useSlackChannels from '../hooks/useSlackChannels'
import useShareTopicMutation from '../mutations/useShareTopicMutation'
import {Dialog} from '../ui/Dialog/Dialog'
import {DialogActions} from '../ui/Dialog/DialogActions'
import {DialogContent} from '../ui/Dialog/DialogContent'
import {DialogDescription} from '../ui/Dialog/DialogDescription'
import {DialogTitle} from '../ui/Dialog/DialogTitle'
import {Select} from '../ui/Select/Select'
import {SelectContent} from '../ui/Select/SelectContent'
import {SelectGroup} from '../ui/Select/SelectGroup'
import {SelectItem} from '../ui/Select/SelectItem'
import {SelectTrigger} from '../ui/Select/SelectTrigger'
import {SelectValue} from '../ui/Select/SelectValue'
import SlackClientManager from '../utils/SlackClientManager'
import findStageById from '../utils/meetings/findStageById'
import PrimaryButton from './PrimaryButton'
import SecondaryButton from './SecondaryButton'









const ShareTopicModalViewerFragment = graphql`
  fragment ShareTopicModal_viewer on User @argumentDefinitions(meetingId: {type: "ID!"}) {
    meeting(meetingId: $meetingId) {
      teamId
      viewerMeetingMember {
        teamMember {
          integrations {
            slack {
              isActive
              botAccessToken
              slackUserId
              slackTeamId
              defaultTeamChannelId
            }
          }
        }
      }
      phases {
        phaseType
        stages {
          id
          ... on RetroDiscussStage {
            reflectionGroup {
              title
            }
          }
        }
      }
    }
  }
`

const query = graphql`
  query ShareTopicModalQuery($meetingId: ID!) {
    viewer {
      ...ShareTopicModal_viewer @arguments(meetingId: $meetingId)
    }
  }
`



const ShareTopicModal = (props) => {
  const {isOpen, onClose, queryRef, meetingId, stageId} = props
  const atmosphere = useAtmosphere()
  const [commit, shareTopicSubmitting] = useShareTopicMutation()
  const {
    submitting: slackOAuthSubmitting,
    submitMutation,
    onError,
    onCompleted
  } = useMutationProps()
  const data = usePreloadedQuery(query, queryRef)
  const viewer = useFragment(ShareTopicModalViewerFragment, data.viewer)
  const {meeting} = viewer

  const stage = _optionalChain([findStageById, 'call', _ => _(_optionalChain([meeting, 'optionalAccess', _2 => _2.phases]), stageId), 'optionalAccess', _3 => _3.stage])
  const topicTitle = _nullishCoalesce(_optionalChain([stage, 'optionalAccess', _4 => _4.reflectionGroup, 'optionalAccess', _5 => _5.title]), () => ( ''))

  const slack = _nullishCoalesce(_optionalChain([meeting, 'optionalAccess', _6 => _6.viewerMeetingMember, 'optionalAccess', _7 => _7.teamMember, 'access', _8 => _8.integrations, 'access', _9 => _9.slack]), () => ( null))
  const isSlackConnected = _optionalChain([slack, 'optionalAccess', _10 => _10.isActive])
  const slackDefaultTeamChannelId = _optionalChain([slack, 'optionalAccess', _11 => _11.defaultTeamChannelId])
  const slackChannels = useSlackChannels(slack)
  const channelsLoading = slackChannels.length === 0 && isSlackConnected
  const isLoading = slackOAuthSubmitting || shareTopicSubmitting

  const defaultSelectedIntegration = isSlackConnected ? 'slack' : ''
  const [selectedIntegration, setSelectedIntegration] = useState(
    defaultSelectedIntegration
  )
  const [selectedChannel, setSelectedChannel] = useState(_nullishCoalesce(slackDefaultTeamChannelId, () => ( '')))

  if (!meeting) {
    return null
  }

  const {teamId} = meeting

  const onIntegrationChange = (integration) => {
    if (integration === 'slack') {
      if (isSlackConnected) {
        setSelectedIntegration('slack')
      } else {
        SlackClientManager.openOAuth(atmosphere, teamId, {
          submitting: slackOAuthSubmitting,
          submitMutation,
          onError,
          onCompleted: () => {
            onCompleted()
            setSelectedIntegration('slack')
          }
        })
      }
    }
  }

  const onChannelChange = (channel) => {
    setSelectedChannel(channel)
  }

  const onShare = () => {
    commit(
      {
        variables: {
          stageId,
          meetingId,
          channelId: selectedChannel
        }
      },
      {
        onSuccess: () => {
          const channel = slackChannels.find((channel) => channel.id === selectedChannel)
          atmosphere.eventEmitter.emit('addSnackbar', {
            key: `topicShared`,
            autoDismiss: 5,
            message: `"${topicTitle}" has been shared to ${_optionalChain([channel, 'optionalAccess', _12 => _12.name])}`,
            action: {
              label: `View message`,
              callback: () => {
                const url = `https://app.slack.com/client/${
                  _nullishCoalesce(_optionalChain([slack, 'optionalAccess', _13 => _13.slackTeamId]), () => ( ''))
                }/${selectedChannel}`
                _optionalChain([window, 'access', _14 => _14.open, 'call', _15 => _15(url, '_blank', 'noopener'), 'optionalAccess', _16 => _16.focus, 'call', _17 => _17()])
              }
            }
          })
          onClose()
        }
      }
    )
  }

  const comingSoonBadge = (
    _jsx('div', { className: "flex items-center justify-center rounded-full bg-slate-300 px-3 py-1"      , children: 
      _jsx('div', { className: "text-center text-xs font-semibold text-slate-600"   , children: "coming soon" })
    })
  )

  const connectButton = (
    _jsx('div', { className: "flex cursor-pointer items-center justify-center rounded-full border bg-white px-3 py-1"        , children: 
      _jsx('div', { className: "text-center text-xs font-semibold text-slate-700"   , children: "connect"})
    })
  )

  const labelStyles = `w-[110px] text-left text-sm font-semibold`
  const fieldsetStyles = `mx-0 mb-[15px] mb-2 flex items-center gap-5 p-0`

  return (
    _jsx(Dialog, { isOpen: isOpen, onClose: onClose, children: 
      _jsxs(DialogContent, { className: "z-10", children: [
        _jsx(DialogTitle, { children: "Share topic" })
        , _jsxs(DialogDescription, { children: ["Where would you like to share the topic \""
                  , topicTitle, "\"?"
        ]})

        , _jsxs('fieldset', { className: fieldsetStyles, children: [
          _jsx('label', { className: labelStyles, children: "Integration"})
          , _jsxs(Select, {
            onValueChange: onIntegrationChange,
            value: selectedIntegration,
            disabled: isLoading,
 children: [
            _jsx(SelectTrigger, { children: 
              selectedIntegration !== '' ? (
                _jsx(SelectValue, {} )
              ) : (
                _jsx('span', { className: "text-slate-600", children: "Select Integration" })
              )
            })
            , _jsx(SelectContent, { children: 
              _jsxs(SelectGroup, { children: [
                _jsx(SelectItem, { value: "slack", endAdornment: !isSlackConnected ? connectButton : null, children: "Slack"

                })
                , _jsx(SelectItem, {
                  value: "teams",
                  disabled: true,
                  endAdornment: comingSoonBadge,
                  className: "data-disabled:opacity-100",
 children: "Teams"

                })
                , _jsx(SelectItem, {
                  value: "mattermost",
                  disabled: true,
                  endAdornment: comingSoonBadge,
                  className: "data-disabled:opacity-100",
 children: "Mattermost"

                })
              ]})
            })
          ]})
        ]})

        , _jsxs('fieldset', { className: fieldsetStyles, children: [
          _jsx('label', { className: labelStyles, children: "Channel"})
          , _jsxs(Select, {
            onValueChange: onChannelChange,
            value: selectedChannel,
            disabled: isLoading || channelsLoading || selectedIntegration === '',
 children: [
            _jsx(SelectTrigger, { isLoading: channelsLoading, children: 
              _jsx(SelectValue, {} )
            })
            , _jsx(SelectContent, { position: "item-aligned", children: 
              _jsx(SelectGroup, { children: 
                selectedIntegration === 'slack' &&
                  slackChannels.map((channel) => (
                    _jsx(SelectItem, { value: channel.id, children: 
                      channel.name
                    }, channel.id)
                  ))
              })
            })
          ]})
        ]})
        , _jsxs(DialogActions, { children: [
          _jsx(SecondaryButton, { onClick: onClose, size: "small", children: "Cancel"

          })
          , _jsx(PrimaryButton, { size: "small", onClick: onShare, disabled: isLoading || channelsLoading, children: "Share"

          })
        ]})
      ]})
    })
  )
}

export default ShareTopicModal
